import { createAction } from '../../techstyle-shared/redux-core';

export const trackQuizPageView = createAction('quiz/TRACK_PAGE_VIEW');
export const trackSkipQuiz = createAction('quiz/TRACK_SKIP_QUIZ');
export const trackQuizQuestionAnswered = createAction(
  'quiz/TRACK_QUIZ_QUESTION_ANSWERED'
);
